/*
 * Created on Thu July 2025
 *
 * Copyright (c) 2025 - Mike Hauber <mhauber@gmail.com>
 */

import { Component, OnInit } from '@angular/core';
import { DescargaService } from './../_services/descargas.service';
import { DescargaRespuesta } from './../_models/descargas';

@Component({
  selector: 'app-tribunal',
  templateUrl: './tribunal.component.html',
  styleUrls: ['./tribunal.component.css']
})
export class TribunalComponent implements OnInit {

  respuesta: DescargaRespuesta;

  constructor(private service: DescargaService) {
    this.respuesta = new DescargaRespuesta();
  }

  ngOnInit() {
    this.service.getAll('files-tribunal').subscribe(
      datos => {
        this.respuesta = datos;
      }
    );
  }

}
